(function () {
  class SizeDrawerOpener extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const drawer = document.querySelector(this.getAttribute('data-drawer'));
        if (drawer) drawer.open(button);
      });
    }
  }

  class SizeDrawer extends HTMLElement {
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);

      this.backdrop = this.querySelector('.size-drawer__backdrop');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      this.backdrop.addEventListener('click', () => this.close());
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });

      this.querySelectorAll('.size-drawer__option').forEach((button) => {
        button.addEventListener('click', () => this.addVariant(button));
      });
    }

    open(opener) {
      this.openedBy = opener;
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      const stickyBar = document.querySelector('.product-sticky-bar');
      if (stickyBar) stickyBar.classList.add('size-drawer-hidden');
    }

    close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      if (this.openedBy) this.openedBy.focus();
      const stickyBar = document.querySelector('.product-sticky-bar');
      if (stickyBar) stickyBar.classList.remove('size-drawer-hidden');
    }

    addVariant(button) {
      if (button.hasAttribute('disabled') || button.classList.contains('loading')) return;
      button.classList.add('loading');
      button.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', 1);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error(response.description);
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: response } }));
          this.close();
          if (this.cart) {
            this.cart.classList.remove('is-empty');
            this.cart.renderContents(response);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          button.classList.remove('loading');
          button.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }
  }

  if (!customElements.get('size-drawer-opener')) customElements.define('size-drawer-opener', SizeDrawerOpener);
  if (!customElements.get('size-drawer')) customElements.define('size-drawer', SizeDrawer);
})();
